angular.module('app.directive')
    .directive('reviewCampaign', function() {
        return {
            templateUrl: 'app/campaign/directives/reviewCampaign.html?app_v=deployDate'
        };
    });